import type { RoutesType } from 'features/mobile-report/types/types';

export const getActiveRoute = (path: string): RoutesType | undefined =>
    path.split('/')[1] as RoutesType;
